import { useRef } from 'react';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Tick from 'assets/tick.svg';
import Download from 'assets/download-active.svg';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { Button, Paper } from '@mui/material';
import html2canvas from 'html2canvas';
import OutputViewerWithoutSource from 'components/signaturePreview/meeting/core/components/OutputViewerWithoutSource';
import { backgroundConfigAtom } from '_state/signature';
import { useRecoilValue } from 'recoil';
// import { useUserActions } from 'hooks';

const DownloadMeetingSignature = () => {
  // const userActions = useUserActions();
  // const verifyStatus = useRecoilValue(verifyStatusAtom);
  const myRef = useRef(null);
  const backgroundConfig = useRecoilValue(backgroundConfigAtom);

  // useEffect(() => {
  //   setTimeout(() => {
  //     // render the virtual background and send mail to the user
  //     if (myRef.current) {
  //       html2canvas(myRef.current, {
  //         allowTaint: true,
  //         useCORS: true,
  //       })
  //         .then(canvas => {
  //           canvas.style.display = 'none';
  //           document.body.appendChild(canvas);
  //           return canvas;
  //         })
  //         .then(canvas => {
  //           const imageDataUrl = canvas.toDataURL('image/jpg');
  //           const binaryString = atob(imageDataUrl.split(',')[1]);
  //           const bytes = new Uint8Array(binaryString.length);
  //           for (let i = 0; i < binaryString.length; i++) {
  //             bytes[i] = binaryString.charCodeAt(i);
  //           }
  //           const hexString = Array.from(bytes, function (byte) {
  //             return ('0' + (byte & 0xff).toString(16)).slice(-2);
  //           }).join('');

  //           console.log(hexString);

  //           const payload = {
  //             username: verifyStatus.payload.name,
  //             email: verifyStatus.payload.workEmail,
  //             image_hex: hexString,
  //           };

  //           userActions.sendMail(payload);
  //         });
  //     }
  //   }, 2000);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  function capture() {
    if (myRef.current) {
      html2canvas(myRef.current, {
        allowTaint: true,
        useCORS: true,
      })
        .then(canvas => {
          canvas.style.display = 'none';
          document.body.appendChild(canvas);
          return canvas;
        })
        .then(canvas => {
          const image = canvas.toDataURL('image/jpg').replace('image/jpg', 'image/octet-stream');
          const a = document.createElement('a');
          a.setAttribute('download', 'v-card.jpg');
          a.setAttribute('href', image);
          a.click();
          canvas.remove();
        });
    }
  }

  return (
    <div className="row h-100 justify-content-center align-items-center">
      <div className="col-lg-7 col-11  py-4">
        <div className="text-center">
          <Box pb={5} className="col-md-6 m-auto" display="flex" justifyContent={'space-between'}>
            <Avatar
              sx={{
                width: '50px',
                height: '50px',
                border: '1px solid #23BB86',
                borderRadius: '50%',
                padding: 1.8,
                mr: 1,
              }}
              variant="rounded"
              alt=""
              src={Tick}
            />
            <Box
              sx={{
                width: '100%',
                borderTop: '2px dotted #23BB86',
                margin: '20px 2px 0 2px',
                transform: 'rotate(-0.07deg)',
              }}
            />
            <Avatar
              sx={{
                width: '50px',
                height: '50px',
                border: '1px solid #23BB86',
                borderRadius: '50%',
                padding: 1.5,
                ml: 1,
              }}
              variant="rounded"
              alt=""
              src={Download}
            />
          </Box>
          <Typography variant="h5" gutterBottom>
            Here's your new virtual background
          </Typography>
          {/* <Typography
            className="col-md-8 m-auto py-3"
            variant="caption"
            display="block"
            gutterBottom
          >
            It's high time to put it to work. Copy it by clicking one of the buttons below the
            preview, and add it to your email client with our step-by-step guide.
          </Typography> */}
        </div>

        <Box
          sx={theme => ({
            // display: 'grid',
            // gap: theme.spacing(1),
            // gridTemplateColumns: '1fr',
          })}
          id="meetingMarkup"
          ref={myRef}
          width="800px"
          height="470px"
        >
          <Paper
            sx={theme => ({
              // minHeight: `calc(min(${[`${theme.spacing(60)}`, `100vh - ${theme.spacing(0)}`].join(
              //   ', ',
              // )}))`,
              // width: '900px',
              // height: '470px',
              height: '100%',
              width: '100%',
              borderRadius: 0,
              display: 'flex',
              overflow: 'hidden',
              boxShadow: 'none',
              // [theme.breakpoints.up('md')]: {
              //   gridColumnStart: 1,
              // },
            })}
          >
            <OutputViewerWithoutSource backgroundConfig={backgroundConfig} />
          </Paper>
        </Box>
        <Stack direction="row" alignItems="center" spacing={2} py={3}>
          <Button
            sx={{
              textTransform: 'none',
              '&.MuiButtonBase-root:hover': {
                bgcolor: '#FF8140',
              },
            }}
            color="secondary"
            variant="contained"
            onClick={capture}
          >
            Download Image
          </Button>
        </Stack>
      </div>
    </div>
  );
};

export default DownloadMeetingSignature;
